import { Badge } from '@mantine/core';
import Link from 'next/link';
import { useProjectId } from '~/hooks/context/useProjectId';

type VersionBadgeProps = {
  contentId: string;
  trunkContentId: string;
  testId?: string;
};

export function VersionBadge({ contentId, trunkContentId, testId }: VersionBadgeProps) {
  const projectId = useProjectId();
  const isLatestVersion = contentId === trunkContentId;

  const versionLabel = isLatestVersion ? 'latest version' : `version #${contentId.slice(0, 5)}`;

  if (!testId) {
    return (
      <Badge
        variant="light"
        color={isLatestVersion ? 'blue' : 'gray'}
      >
        {versionLabel}
      </Badge>
    );
  }

  return (
    <Badge
      variant="light"
      color={isLatestVersion ? 'blue' : 'gray'}
      component={Link}
      className="cursor-pointer"
      href={`/project/${projectId}/test/${testId}${isLatestVersion ? '' : `?version=${contentId}`}`}
      target="_blank"
    >
      {versionLabel}
    </Badge>
  );
}
